module.exports = __webpack_public_path__ + "media/images/logo-mobile-4336cdade4b41606ab1aa3866c3c80d3.png";